<template>
    <div class="btn-group btn-group-sm">
      <!--<button v-if="can_access('deal','view') && row.sub_count==1" class="btn" :class="row.approved_by?'btn-completed':'btn-pending'" title="Approve Deal" @click="showModal('approve')"><i class="fa fa-check-circle"></i></button>-->
      <button class="btn btn-info" title="Sub Tickets"
        :class="{ '-nested-comp-open-btn': isDisplayRowVisible }"
        @click="toggleNestedComp('ClientTrades')"
        v-if="parseInt(row.client_deals_quantity) > 0">
        <i class="fa fa-list-ul"></i>
      </button>
      <!-- <button v-if="(can_access('deal','view'))" class="btn btn-edit" title="View Deal" @click="showModal('view')"><i class="fa fa-eye"></i></button> -->
      <button v-if="((!row.approved_by || can_access('deal_after_approval','modify')) && !row.deleted_at && can_access('deal','modify'))" class="btn btn-edit" title="Edit Deal" @click="showModal('edit')"><i class="fa fa-edit"></i></button>
      <button v-if="can_access('deal','modify')" class="btn btn-gray" title="Copy Deal" @click="showModal('copy')"><i class="fa fa-copy"></i></button>
      <!-- <button v-if="can_access('deal','modify') && row.open" class="btn btn-pending" title="Internal transfer" @click="showModal('IT')"><i class="fa fa-exchange"></i></button> -->
      <!--<button v-if="can_access('deal','modify')" class="btn btn-info" title="Create Sub Ticket" @click="showModal('sub_deal')">SUB TICKET</button>-->
      <button v-if="((!row.deleted_at) && can_access('deal','modify'))" class="btn btn-danger" title="Cancel Deal" @click="showModal('delete')"><i class="fa fa-times"></i></button>
  
      <b-modal ref="edit-deal-out" :title="(action=='copy'?'Add':toCapitalize(action))+' Deal'" size="xl" hide-footer>
        <!-- <ViewDealForm :rows="rowData" :forceRerender="tradeFormReRender" v-if="action=='view'"/> -->
        <DealInvoice :row="rowData" @tradeFormReRender="tradeFormReRender" v-if="action=='approve'"/>
        <AddDealForm :rows="rowData" :forceRerender="tradeFormReRender" v-else/>
      </b-modal>
  
      <b-modal ref="notify-customer" :title="'NOTIFY CUSTOMER'" :size="notify_customer?'lg':'sm'" hide-footer>
        
        <div class="form-group form-check">
          <input type="checkbox" class="form-check-input" id="notify_customer_checkbox" v-model="notify_customer">
          <label class="form-check-label" for="notify_customer_checkbox">Notify Customer</label>
        </div>
        <div v-if="notify_customer">
          <div class="form-group">
              <label class="col-lg-2 control-label">To</label>
              <div class="col-lg-12">
                  <input type="text" placeholder="" :value="row.email" :readonly="true" class="form-control">
              </div>
          </div>
          <div class="form-group">
              <label class="col-lg-2 control-label">Subject</label>
              <div class="col-lg-12">
                  <input type="text" placeholder="" v-model="email_subject" class="form-control">
              </div>
          </div>
          <div class="form-group">
              <label class="col-lg-2 control-label">Message</label>
              <div class="col-lg-12">
                <!-- <input type="text" placeholder="" v-model="email_body" class="form-control" :readonly="true"> -->
                <vue-editor v-model="email_body" :editorToolbar="customToolbar" :readonly="true"></vue-editor>
              </div>
          </div>
          <!-- <div class="form-group">
              <label class="col-lg-2 control-label">Attachment(s):</label>
              <div class="col-lg-12" v-if="email_attachments">
                  <a class="" v-for="file in email_attachments" :key="file" target="_blank"  :href="get_baseURL()+file"><i class="fa fa-file-pdf-o pdf-icon" aria-hidden="true"></i></a>
              </div>
          </div> -->
        </div>
        <div class="form-group">
          <div class="col-lg-12">
            <button type="button" class="btn btn-lg btn-info pull-right mt-2" @click.prevent="showModal(action)">{{(notify_customer?'Send & ':'')+'Cancel Deal'}}</button>
          </div>
        </div>
      </b-modal>
    </div>
  </template>
  <script>
  import $ from 'jquery';
  import ViewDealForm from '@/components/Accounts/ViewDealForm';
  import DealInvoice from '@/components/Accounts/DealInvoice';
  import common from '@/assets/js/common.js';
  import { VueEditor } from "vue2-editor";
  export default {
    props: ['row', 'nested','refresh'],
    mixins: [common],
    data(){
      return {
        show: 1,
        confirm_delete: false,
        confirm_send_email: false,
        rowData:{},
        action:'',
        notify_customer: false,
        email_subject: '',
        email_body: '',
        customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]],
      }
    },
    components: {  AddDealForm: () => import('@/components/Accounts/AddDealForm'),DealInvoice,ViewDealForm, VueEditor },
    mounted () {
      //$(this.$el).find('button[title]').tooltip()
    },
    computed: {
      isDisplayRowVisible () {
        if (this.nested.comp !== 'ClientTrades') return
        return this.nested.visible
      },
    },
    methods: {
      tradeFormReRender(response) {
        if(response.code==0){
          this.$refs['edit-deal-out'].hide();
          this.show = 1;
          this.refresh();
          this.$toasted.success("Successfully Added",{duration:1000});
        }
      },
      toggleNestedComp (comp) {
        const { nested } = this
        if (nested.comp === comp) return nested.$toggle()
        nested.$toggle(comp, true)
      },
      showModal(action) {
        //if(this.row.sub_count <= 1 || action == 'sub_deal'){
          this.action = action;
          if(action=='edit'){
              this.rowData = this.duplicate(this.row);
              this.rowData.action = 'draft'
              //this.rowData.account_number = '';
              //this.rowData.client_name = '';
          }
          if(action=='view'){
              this.rowData = this.duplicate(this.row);
              //this.rowData.account_number = '';
              //this.rowData.client_name = '';
          }
          else if(action=='delete'){
            //if(this.confirm_delete || confirm("Do you really want to cancel?")){
              /* this.confirm_delete = true;
              if(!this.confirm_send_email){
                this.confirm_send_email = true;
                this.email_subject = " Contract Note - "+this.row.contract_note+" has been cancelled";
                this.email_body = 'Hello '+this.row.client_name+', We regret to inform you that your contract note('+this.row.contract_note+') has been cancelled.';
                this.$refs['notify-customer'].show();
                return;
              } */
              this.show = false;
              this.rowData = this.duplicate(this.row);
              this.rowData.status = 0;
              this.rowData.notify_customer = this.notify_customer;
              this.rowData.email_subject = this.email_subject;
              this.rowData.email_body = this.email_body;
              this.$refs['notify-customer'].hide();
              this.confirm_send_email = false;
              this.confirm_delete = false;
            //}else return;
          }
          else if(action=='sub_deal'){
            this.rowData = this.duplicate(this.row);
            this.rowData.action = 'sub_deal'
            this.rowData.id = '';
          }
          else if(action=='copy'){
            this.rowData = this.duplicate(this.row);
            this.rowData.action = 'draft'
            this.rowData.id = '';
            this.rowData.broker_ref = '';
          }
          else if(action=='IT'){
            this.rowData = this.duplicate(this.row);
            this.rowData.action = 'create'
            this.rowData.id = '';
            this.rowData.contract_note = '';
            this.rowData.ticket_number = '';
            this.rowData.approved_at = '';
            this.rowData.approved_by = '';
            this.rowData.counterparty_id = this.rowData.custodian_id;
            this.rowData.custodian_id = ''
            this.rowData.counterparty_name = this.rowData.custodian_name;
            this.rowData.custodian_name = '';
            this.rowData.type = 'INTERNAL TRANSFER';      
            //this.rowData.account_number = '';
            //this.rowData.client_name = '';
          }
          this.$refs['edit-deal-out'].show()
        /* }else{
          this.$toasted.info("You can not do this action in overall ticket",{duration:1500});
        } */
      },
    }
  }
  </script>
  <style>
  .-nested-comp-open-btn {
    color: #fff !important;
    background-color: #337ab7 !important;
  }
  dd, dt {
      line-height: 1.42857143;
  }
  </style>
  